//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function createTagService(name) {
    try {
        const response = await api.post("/tags", {nome: name });
        return response;
    } catch {
        toast.error("Erro ao criar tag");
        return null;
    }
}